var _defs, _rect, _rect2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooleanmaths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "neonGlowCalc2",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "blur1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calcMetal2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#132227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#070B0D"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#101418"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 89,
    height: 89,
    rx: 13,
    fill: "url(#calcMetal2)",
    stroke: "#4DD0E1",
    strokeWidth: 2.2,
    filter: "url(#neonGlowCalc2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4DD0E1",
    strokeWidth: 2,
    filter: "url(#neonGlowCalc2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 12,
    x2: 50,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 50,
    x2: 88,
    y2: 50
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4DD0E1",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    fill: "none",
    filter: "url(#neonGlowCalc2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 22,
    x2: 30,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 30,
    x2: 38,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 30,
    x2: 78,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 62,
    x2: 38,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 62,
    x2: 22,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 65,
    x2: 78,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 75,
    x2: 78,
    y2: 75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooleanmaths);
export default __webpack_public_path__ + "static/media/booleanmaths.20135a0f4a28174d61f436df14e70cf4.svg";
export { ForwardRef as ReactComponent };